"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bounds = void 0;
var rotateVector2_1 = require("./util/rotateVector2");
/**
 * Immutable bounding box structure.
 */
var Bounds = /** @class */ (function () {
    function Bounds(x, y, width, height, angle) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.angle = angle;
    }
    /**
     * Returns a new axis-aligned version of the object.
     */
    Bounds.prototype.alignToAxis = function () {
        if (this.angle === 0) {
            return this;
        }
        var _a = this._computeCorners(), tl = _a.tl, tr = _a.tr, bl = _a.bl, br = _a.br;
        var x = Math.min(tl.x, tr.x, bl.x, br.x);
        var y = Math.min(tl.y, tr.y, bl.y, br.y);
        var width = Math.max(tl.x, tr.x, bl.x, br.x) - x;
        var height = Math.max(tl.y, tr.y, bl.y, br.y) - y;
        return new Bounds(x, y, width, height, 0);
    };
    /**
     * Calculates the absolute coordinates of each corner accounting for rotation.
     */
    Bounds.prototype._computeCorners = function () {
        var _a = this, width = _a.width, height = _a.height, angle = _a.angle;
        var halfWidth = 0.5 * width;
        var halfHeight = 0.5 * height;
        var _b = rotateVector2_1.rotateVector2(halfWidth, halfHeight, angle), xOffset = _b.x, yOffset = _b.y;
        var centerX = this.x + xOffset;
        var centerY = this.y + yOffset;
        var radius = Math.sqrt(halfWidth * halfWidth + halfHeight * halfHeight);
        var atan = Math.atan(width / height);
        return {
            tl: {
                x: centerX + Math.sin(Math.PI * 2 - atan + angle) * radius,
                y: centerY - Math.cos(Math.PI * 2 - atan + angle) * radius
            },
            tr: {
                x: centerX + Math.sin(atan + angle) * radius,
                y: centerY - Math.cos(atan + angle) * radius
            },
            bl: {
                x: centerX + Math.sin(Math.PI + atan + angle) * radius,
                y: centerY - Math.cos(Math.PI + atan + angle) * radius
            },
            br: {
                x: centerX + Math.sin(Math.PI - atan + angle) * radius,
                y: centerY - Math.cos(Math.PI - atan + angle) * radius
            }
        };
    };
    return Bounds;
}());
exports.Bounds = Bounds;
//# sourceMappingURL=Bounds.js.map